import "../scss/main.scss";

import { loadSlider } from "../components/slider-component";
import { headerFooterDefer } from "../components/header-footer-defer";
import { sectionsLoadDefer } from "../components/sections-defer";
import executeCustomSelects from "../components/custom-select";
import { $Qll } from "graditify-utils";
import animateStair from "../utils/animate-stair";
import { cloudinaryIframDefer } from "../components/cloudinary-iframe";
import CardProduct from "../../assets/product-card.module";

headerFooterDefer();
loadSlider();
sectionsLoadDefer();
animateStair();
cloudinaryIframDefer();

window.customElements.define("card-product", CardProduct);

document.addEventListener("DOMContentLoaded", () => {
  const customSelectors = $Qll(".custom-select");
  if (!customSelectors.length) return;

  return executeCustomSelects()
})
